import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.scss';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            /**
             * Désactive le refetch des requetes quand l'onglet
             * redevient actif
             */
            refetchOnWindowFocus: false,
            /**
             * Désactive le faite que les requêtes en erreur 
             * soient réessayé 3 fois.
             */
            retry: false
        }
    }
});

// Provisoire pour simuler les attributs de la div du CMS
// const rootElement = document.getElementById('legal-entity-account-opening');
// if (rootElement) {
//     rootElement.setAttribute('data-brandcode', 'CGPAS');
//     rootElement.setAttribute('data-brandname', 'MeilleurTaux');
//     rootElement.setAttribute('data-brandslug', 'meilleurtaux');
//     rootElement.setAttribute('data-sitecode', 'DAS');
// }
// const root = ReactDOM.createRoot(rootElement as HTMLElement);

// const rootElement = document.getElementById('legal-entity-account-opening');
// if (rootElement) {
//     rootElement.setAttribute('data-brandcode', 'ORI');
//     rootElement.setAttribute('data-brandname', 'La Financiere d Orion');
//     rootElement.setAttribute('data-brandslug', 'orion');
//     rootElement.setAttribute('data-sitecode', 'ORI');
// }
// const root = ReactDOM.createRoot(rootElement as HTMLElement);

const root = ReactDOM.createRoot(
    document.getElementById('legal-entity-account-opening') as HTMLElement
);

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
